class CheckoutConfirmationOrderEmailController {
    constructor(shopperService, settings) {
        this.shopperService = shopperService;
        this.settings = settings;
    }

    $onInit() {
        this.shouldHideTrackMyOrderLink = this.order.DeliveryMethod === this.settings.orderConfirmation.expressDeliveryMethod;
        this.shopperService.getCurrentShopper().then((shopper) => {
            this.currentShopperEmail = shopper.Email;
        });
    }
}

CheckoutConfirmationOrderEmailController.$inject = ['ShopperService', 'Settings'];

const checkoutConfirmationOrderEmailControllerComponentDefinition = {
    bindings: {
        order: '<',
    },
    controller: CheckoutConfirmationOrderEmailController,
    template: require('./checkout-confirmation-order-email.component.html').trim(),
};

module.exports = {
    CheckoutConfirmationOrderEmailController,
    checkoutConfirmationOrderEmailControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/confirmation/checkout-confirmation-order-email.component.js